export const REFUND_DETAIL_TEXT = {
  KOR: {
    title: '환급현황 상세보기',
    refund: '환급 완료',
    remittance: '송금',
    van: '공항 환급',
    unRefund: '미환급',
    close: '닫기',
  },
  ENG: {
    title: 'Refund Detail',
    refund: 'Refund Completed',
    remittance: 'Remittance',
    van: 'Airport Refund',
    unRefund: 'Pending Refund',
    close: 'Close',
  },
};
